import { useEffect, useState } from 'react';
import { Loader2, CheckCircle, XCircle } from 'lucide-react';
import { adminApi } from '../lib/api';

export default function AdminInnstillinger() {
  const [current, setCurrent] = useState('');
  const [newPw, setNewPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  const [status, setStatus] = useState(null);
  const [purge, setPurge] = useState(null);

  useEffect(() => {
    adminApi.get('/admin/system-status').then((r) => setStatus(r.data));
    adminApi.get('/admin/purge-old-leads/preview').then((r) => setPurge(r.data));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setMsg(''); setError('');
    if (newPw !== confirm) { setError('Passord stemmer ikke overens'); return; }
    if (newPw.length < 8) { setError('Nytt passord må være minst 8 tegn'); return; }
    setLoading(true);
    try {
      await adminApi.post('/admin/change-password', { current_password: current, new_password: newPw });
      setMsg('Passordet er oppdatert');
      setCurrent(''); setNewPw(''); setConfirm('');
    } catch (err) {
      setError(err.response?.data?.detail || 'Feil oppsto');
    } finally { setLoading(false); }
  };

  const doPurge = async () => {
    if (!window.confirm(`Dette vil slette ${purge?.count || 0} henvendelser eldre enn 12 måneder. Er du sikker?`)) return;
    await adminApi.post('/admin/purge-old-leads');
    adminApi.get('/admin/purge-old-leads/preview').then((r) => setPurge(r.data));
  };

  const inputCls = "w-full bg-[#FAF8F5] border-0 rounded-lg px-4 py-2.5 focus:outline-none text-sm";

  return (
    <div className="space-y-8 max-w-3xl">
      <h1 className="font-display text-3xl font-bold text-[#0A1F44]">Innstillinger</h1>

      <section className="bg-white rounded-xl p-6 border border-[#0A1F44]/10">
        <h2 className="font-display text-xl font-bold text-[#0A1F44] mb-4">Bytt passord</h2>
        <form onSubmit={submit} className="space-y-3 max-w-md">
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#64748B]">Nåværende passord</label>
            <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)} className={inputCls} required data-testid="current-pw" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#64748B]">Nytt passord</label>
            <input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} className={inputCls} required data-testid="new-pw" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#64748B]">Bekreft nytt passord</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inputCls} required data-testid="confirm-pw" />
          </div>
          {error && <div className="text-sm text-red-600">{error}</div>}
          {msg && <div className="text-sm text-green-700">{msg}</div>}
          <button type="submit" disabled={loading} className="bg-[#0A1F44] text-white px-5 py-2.5 rounded-lg text-sm font-semibold flex items-center gap-2" data-testid="change-pw-btn">
            {loading ? <><Loader2 className="animate-spin" size={14} /> Oppdaterer…</> : 'Oppdater passord'}
          </button>
        </form>
      </section>

      <section className="bg-white rounded-xl p-6 border border-[#0A1F44]/10">
        <h2 className="font-display text-xl font-bold text-[#0A1F44] mb-4">Systemstatus</h2>
        <div className="space-y-2 text-sm">
          {status ? (
            <>
              <div className="flex items-center gap-2">
                {status.supabase ? <CheckCircle className="text-green-600" size={16} /> : <XCircle className="text-red-600" size={16} />}
                Supabase
              </div>
              <div className="flex items-center gap-2">
                {status.resend ? <CheckCircle className="text-green-600" size={16} /> : <XCircle className="text-red-600" size={16} />}
                Resend
              </div>
              <div className="text-[#64748B] text-sm pt-2">
                Siste lead: {status.latest_lead ? new Date(status.latest_lead).toLocaleString('no-NO') : '—'}
              </div>
            </>
          ) : <div className="text-[#64748B]">Laster…</div>}
        </div>
      </section>

      <section className="bg-white rounded-xl p-6 border border-[#0A1F44]/10">
        <h2 className="font-display text-xl font-bold text-[#0A1F44] mb-4">Datahåndtering</h2>
        <p className="text-sm text-[#64748B] mb-3">
          Leads eldre enn 12 måneder kan slettes her for å oppfylle GDPR-retensjonen.
        </p>
        <p className="text-sm text-[#334155] mb-4">
          <strong>{purge?.count || 0}</strong> henvendelser vil bli slettet
          {purge?.last_purge && <span className="block text-xs text-[#64748B] mt-1">Sist slettet: {new Date(purge.last_purge.created_at).toLocaleString('no-NO')}</span>}
        </p>
        <button onClick={doPurge} disabled={!purge?.count} className="bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white px-5 py-2.5 rounded-lg text-sm font-semibold" data-testid="purge-btn">
          Slett eldre henvendelser
        </button>
      </section>
    </div>
  );
}
